/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCreatedByField
 */
export interface DatabaseCreatedByField extends DatabaseField {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseCreatedByField
     */
    userFields?: Array<string>;
}

/**
 * Check if a given object implements the DatabaseCreatedByField interface.
 */
export function instanceOfDatabaseCreatedByField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCreatedByFieldFromJSON(json: any): DatabaseCreatedByField {
    return DatabaseCreatedByFieldFromJSONTyped(json, false);
}

export function DatabaseCreatedByFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCreatedByField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'userFields': !exists(json, 'userFields') ? undefined : json['userFields'],
    };
}

export function DatabaseCreatedByFieldToJSON(value?: DatabaseCreatedByField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'userFields': value.userFields,
    };
}

